import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import SuccessIcon from "~images/ic_check_circle_24px@3x.png";
import { DialogContent } from "@mui/material";

const useStyles = makeStyles((theme: any) => ({
  paper: {
    borderRadius: 8,
  },
  paperFullScreen: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    padding: "30px",
  },
  dialogTitle: { display: "none" },
  contentCenter: {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: theme.spacing(3),
    fontSize: 18,
  },
  icon: {
    width: 72,
    height: 72,
    display: "block",
    margin: "0 auto",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  button: {
    alignSelf: "center",
    fontWeight: 700,
  },
}));

interface SuccessDialogProps {
  openDialog: boolean;
  value: React.ReactNode;
}

const SuccessDialog = ({ openDialog, value }: SuccessDialogProps) => {
  const [open, setOpen] = useState(openDialog);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const classes = useStyles();

  const MARKETPLACE_URL = process.env.REACT_APP_MARKETPLACE_URL || "/";

  const redirect = () => {
    window.location.assign(MARKETPLACE_URL);
  };

  const handleClose = () => {
    redirect();
  };

  useEffect(() => setOpen(openDialog), [openDialog]);

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        fullWidth
        maxWidth="xs"
        classes={{
          paper: classes.paper,
          paperFullScreen: classes.paperFullScreen,
        }}
        BackdropProps={{ style: { backgroundColor: "rgba(0,0,0,0.35)" } }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          className={classes.dialogTitle}
        />
        <DialogContent className={classes.contentCenter}>
          <img alt="Éxito" src={SuccessIcon} className={classes.icon} />
          {value}
        </DialogContent>
        <DialogActions>
          <div className={classes.button}>
            <Button onClick={redirect} color="primary" autoFocus>
              Aceptar
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SuccessDialog;
